import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12 col-sm-9 mx-auto text-secondary py-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "PROFILE", -1)
const _hoisted_3 = { class: "row border border-1 border-top-0 border-start-0 border-end-0 py-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-primary" }, "EMAIL", -1)
const _hoisted_5 = { class: "col offset-sm-1 text-center text-sm-start" }
const _hoisted_6 = { class: "row border border-1 border-top-0 border-start-0 border-end-0 py-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-primary" }, "NAME", -1)
const _hoisted_8 = { class: "col offset-sm-1 text-center text-sm-start" }
const _hoisted_9 = { class: "row py-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 text-primary" }, "PROJECTS", -1)
const _hoisted_11 = { class: "col offset-sm-1 text-center text-sm-start" }
const _hoisted_12 = { class: "text-info" }

import { useClientStore } from "@/store/ClientStore";
import { storeToRefs } from "pinia";

const __default__ = {
  name: "MyProfile",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useClientStore();
const { clientData } = storeToRefs(store);

return (_ctx: any,_cache: any) => {
  return (_unref(clientData) !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(clientData).email), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(clientData).name), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(clientData).projectsCount), 1),
            _createTextVNode(" / " + _toDisplayString(_unref(clientData).maxAllowedProjects), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})